<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_037"><strong>5.</strong> On the bottom of the bumblebee’s body, place a drop of craft glue and lay the magnet on the glue. Allow the glue to set for a couple of hours.</a></p><a id="file_037">
<p class="image"><img alt="Image" src="images/f0014-06.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_037.vue?4cd30d6c